<template>
  <div class="find-pwd-next">
    <h1>忘记密码</h1>
    <h2>Forget the password</h2>
    <div class="find-pwd-next-form form-wrap">
      <div class="input-wrap no-border">
        <label class="phone-code">验证码已发送至：</label>
        <p>{{phone}}</p>
      </div>
      <div class="input-wrap">
        <label>验证码</label>
        <input type="text" v-model="AuthCode" class="qr-input" v-focus="true">
        <a v-if="!qrLoading" class="qrcode" @click="fetchCode">获取验证码</a>
        <p v-else class="qr-loading">已发送({{loadSeconds}}s)</p>
      </div>
      <div class="input-wrap">
        <label>新密码</label>
        <input type="password" v-model="PassWord">
      </div>
      <button class="login-btn" @click="ok">提交</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'signUp',
  data() {
    return {
      PhoneNumber: '',
      UserName: '',
      AuthCode: '',
      PassWord: '',
      loadSeconds: 60,
      qrLoading: false,
      interval: null,
      phone: this.$store.getters.phone
    }
  },
  methods: {
    countLoadSeconds() {
      if (this.loadSeconds > 0) {
        this.qrLoading = true
        this.interval = setInterval(() => {
          this.loadSeconds--
        }, 1000)
      }
    },
    fetchCode() {
      this.$store
        .dispatch('FetchForgetCode', this.phone)
        .then(() => {
          this.$message({
            message: '短信发送成功',
            type: 'success'
          })
          this.countLoadSeconds()
        })
        .catch(() => {})
    },
    ok() {
      let data = {
        PhoneNumber: this.$store.getters.phone,
        AuthCode: this.AuthCode,
        PassWord: this.PassWord
      }
      this.$store
        .dispatch('ChangePassWord', data)
        .then(() => {
          this.$message({
            message: '修改密码成功',
            type: 'success'
          })
          this.$router.push({ path: '/login/find-pwd-ok' })
        })
        .catch(() => {})
    }
  },
  watch: {
    loadSeconds(val) {
      if (val < 0) {
        this.qrLoading = false
        clearInterval(this.interval)
      }
    }
  },
  created() {
    this.countLoadSeconds()
  }
}
</script>
<style lang="less" scoped>
.find-pwd-next {
  h2 {
    margin-bottom: 55px;
  }
  .input-wrap {
    &.no-border {
      justify-content: flex-start;
      border: none;
      label {
        width: 50%;
      }
      p {
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
}
</style>
